import { inject, Injectable } from '@angular/core';
import { I18nService } from '../../../core/services/i18n.service';
import { ActivationServiceResult } from '../../interfaces/activation/activation-service-result';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';

@Injectable({
  providedIn: 'root'
})
export class ActivationResultToTableDataMapperService {

  i18n = inject(I18nService);

  public map(shopActivationResult: ActivationServiceResult, type: 'SHOP' | 'CONTRACT'): DialogTableDataRow[] {
    return [
      {
        titleStyleClass: 'font-bold',
        title: 'Status',
        value: this.i18n.i18nLng()[type + '_' + (type === 'SHOP' ? shopActivationResult.shopOnboardingStatus : shopActivationResult.pspContractStatus) + '_STATUS']
      },
      {
        titleStyleClass: 'font-bold',
        title: 'Info',
        value: this.i18n.i18nLng()[type + '_' + (type === 'SHOP' ? shopActivationResult.shopOnboardingStatus : shopActivationResult.pspContractStatus) + '_MSG']
      }
    ];
  }
}
